import {floatingCeil, floatingFloor} from '../../../utils/numerals/floating';

export const iterateCheckboxes = ( chooser, query ) => {
	let q = query;

	Array.from( chooser.querySelectorAll( 'li.checkboxes:not(.disabled):not(.hidden)' ) ).forEach( ( it ) => {
		const name = it.dataset.for;
		let values = '';

		Array.from( it.querySelectorAll( 'input[name*="["][value]:checked' ) ).forEach( ( input ) => {
			const value = input.value;

			values += `${value},`;
		} );

		if ( values.length > 0 )
		{
			values = values.substr( 0, values.length - 1 );
			
			if ( q !== '' )
			{
				q += '&';
			}
			
			q += `${name}=${values}`;
		}
	} );

	return q;
};

export const iterateRanges = ( chooser, query ) => {
	let q = query;
	
	Array.from( chooser.querySelectorAll( 'div.range' ) ).forEach( ( it ) => {
		if ( it.parentNode.classList.contains( 'disabled' ) )
		{
			return;
		}

		const name = it.dataset.name;
		const coefficient = name === 'price' ? 1000000 : 1;
		const min = it.dataset.min;
		const max = it.dataset.max;
		let userMin = it.querySelector( `[name="${name}[user_min]"]` ).value.replace( ',', '.' );
		let userMax = it.querySelector( `[name="${name}[user_max]"]` ).value.replace( ',', '.' );
		let values = '';

		if ( Number( min ) < Number( userMin ) )
		{
			userMin = userMin * coefficient;
			values += userMin;
		}

		values += '-';

		if ( Number( max ) > Number( userMax ) )
		{
			userMax = userMax * coefficient;
			values += userMax;
		}

		if ( values === '-' )
		{
			values = '';
		}
		
		if ( values !== '' )
		{
			if ( q !== '' )
			{
				q += '&';
			}
			
			q += `${name}=${values}`;
		}
	} );

	return q;
};
